var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5835 3.16675H9.50016C8.66031 3.16675 7.85486 3.50038 7.26099 4.09424C6.66713 4.68811 6.3335 5.49356 6.3335 6.33341V31.6667C6.3335 32.5066 6.66713 33.3121 7.26099 33.9059C7.85486 34.4998 8.66031 34.8334 9.50016 34.8334H28.5002C29.34 34.8334 30.1455 34.4998 30.7393 33.9059C31.3332 33.3121 31.6668 32.5066 31.6668 31.6667V14.2501L20.5835 3.16675Z",
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5835 3.16675V14.2501H31.6668",
    stroke: "#030303",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 27,
    r: 11,
    fill: "#030303"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1536_879)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6464 26.6464C31.8417 26.4512 32.1583 26.4512 32.3536 26.6464L34.3536 28.6464C34.5488 28.8417 34.5488 29.1583 34.3536 29.3536C34.1583 29.5488 33.8417 29.5488 33.6464 29.3536L32 27.7071L30.3536 29.3536C30.1583 29.5488 29.8417 29.5488 29.6464 29.3536C29.4512 29.1583 29.4512 28.8417 29.6464 28.6464L31.6464 26.6464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 26.5C32.2761 26.5 32.5 26.7239 32.5 27V31.5C32.5 31.7761 32.2761 32 32 32C31.7239 32 31.5 31.7761 31.5 31.5V27C31.5 26.7239 31.7239 26.5 32 26.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3319 22.0043C31.0116 21.9792 31.6882 22.1086 32.3107 22.3827C32.9333 22.6568 33.4856 23.0684 33.9262 23.5866C34.2819 24.0051 34.5573 24.4843 34.7398 25H35.0002C35.6667 25.0004 36.3145 25.2228 36.8406 25.6321C37.3666 26.0413 37.7415 26.6141 37.9059 27.26C38.0703 27.9059 38.0149 28.5882 37.7485 29.1992C37.4821 29.8101 37.0198 30.315 36.4346 30.634C36.1921 30.7662 35.8884 30.6768 35.7562 30.4343C35.624 30.1919 35.7134 29.8882 35.9559 29.756C36.346 29.5433 36.6542 29.2067 36.8318 28.7994C37.0095 28.3921 37.0464 27.9373 36.9368 27.5067C36.8272 27.0761 36.5773 26.6942 36.2266 26.4214C35.8758 26.1485 35.4442 26.0003 34.9999 26H34.3702C34.1423 26 33.9432 25.8458 33.8861 25.6251C33.7537 25.1129 33.5069 24.6374 33.1642 24.2343C32.8216 23.8312 32.392 23.5111 31.9078 23.2979C31.4236 23.0847 30.8974 22.9841 30.3687 23.0036C29.84 23.0231 29.3226 23.1622 28.8554 23.4104C28.3882 23.6586 27.9834 24.0095 27.6713 24.4367C27.3592 24.8639 27.1481 25.3563 27.0537 25.8769C26.9593 26.3974 26.9842 26.9326 27.1264 27.4422C27.2687 27.9518 27.5246 28.4225 27.8749 28.8189C28.0578 29.0258 28.0382 29.3418 27.8313 29.5247C27.6244 29.7075 27.3084 29.688 27.1256 29.4811C26.6751 28.9714 26.3461 28.3662 26.1632 27.711C25.9804 27.0559 25.9484 26.3678 26.0697 25.6985C26.1911 25.0292 26.4626 24.3961 26.8638 23.8469C27.265 23.2976 27.7855 22.8464 28.3862 22.5273C28.9869 22.2081 29.6521 22.0293 30.3319 22.0043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6464 26.6464C31.8417 26.4512 32.1583 26.4512 32.3536 26.6464L34.3536 28.6464C34.5488 28.8417 34.5488 29.1583 34.3536 29.3536C34.1583 29.5488 33.8417 29.5488 33.6464 29.3536L32 27.7071L30.3536 29.3536C30.1583 29.5488 29.8417 29.5488 29.6464 29.3536C29.4512 29.1583 29.4512 28.8417 29.6464 28.6464L31.6464 26.6464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1536_879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(26 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.f2922356bbf60e15b56feda202da4795.svg";
export { ForwardRef as ReactComponent };